"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
const uuid = require("uuid");
let LanguageConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.localIp = "";
    this.localAddress = "";
    this.systemProxyConfig = "";
    this.usingSystemProxy = false;
    this.localIpLoading = false;
    this.systemProxyLoading = false;
    this.networkConfig = "none";
    this.configForm = {
      proxy_protocol: "http",
      proxy_ip: "127.0.0.1",
      proxy_port: 1080
    };
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getConnectConfig();
    });
  }
  getConnectConfig() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/storages/preference/connect_config`);
        this.networkConfig = response.data.value.networkConfig;
        if (this.networkConfig === "selfproxy") {
          try {
            let response_config = yield API.get(`api://base.local/storages/preference/proxy_config`);
            this.configForm = response_config.data.value.proxyConfig;
          } catch (error) {
            yield API.put(`api://base.local/storages/preference/proxy_config`, {
              proxyConfig: {
                proxy_protocol: "http",
                proxy_ip: "127.0.0.1",
                proxy_port: 1080
              }
            });
          }
        }
      } catch (error) {
        yield API.put(`api://base.local/storages/preference/connect_config`, {
          networkConfig: "none"
        });
      }
    });
  }
  changeNetworkConfig() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/connect_config`, {
          networkConfig: this.networkConfig
        });
        if (this.networkConfig === "selfproxy") {
          try {
            let response_config = yield API.get(`api://base.local/storages/preference/proxy_config`);
            this.configForm = response_config.data.value.proxyConfig;
          } catch (error) {
          }
        }
      } catch (error) {
      }
    });
  }
  saveConfig() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/proxy_config`, {
          proxyConfig: this.configForm
        });
        this.$message.success(this.$t("networkconfig.save_config_success"));
      } catch (error) {
      }
    });
  }
  getLocalIp() {
    return __async(this, null, function* () {
      this.localIpLoading = true;
      try {
        const response = yield API.post(`api://base.local/system/proxy/check`, {
          "ip_url": "https://api.kuajingvs.com/api/v1/ip/current"
        });
        this.localIp = response.data.ip_without_proxy;
        this.localAddress = response.data.address_without_proxy;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.localIpLoading = false;
      }
    });
  }
  checkSystemProxy() {
    return __async(this, null, function* () {
      this.systemProxyLoading = true;
      try {
        const response = yield API.post(`api://base.local/system/proxy/check`, {
          "ip_url": "https://api.kuajingvs.com/api/v1/ip/current"
        });
        this.usingSystemProxy = response.data.is_using_system_proxy;
        if (response.data.is_using_system_proxy) {
          this.systemProxyConfig = this.$t("networkconfig.using_system_proxy") + response.data.ip_with_default + " " + response.data.address_default;
        } else {
          this.systemProxyConfig = this.$t("networkconfig.not_using_system_proxy");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.systemProxyLoading = false;
      }
    });
  }
};
LanguageConfig = __decorateClass([
  Component({
    components: {}
  })
], LanguageConfig);
export {
  LanguageConfig as default
};
